import styled, { css } from 'styled-components'
import Box from 'components/shared/Box'
import promotionBadge from 'assets/icons/promotionBadge.svg'
import { respondAbove } from 'styles/mediaQueries'

export interface PromotionBadgeBoxProps {
    top?: [number, number]
    bottom?: [number, number]
    left?: [number, number]
    right?: [number, number]
}

export const PromotionBadgeBox = styled(Box)<PromotionBadgeBoxProps>`
    position: absolute;
    background-image: url(${promotionBadge});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: 78px;
    display: flex;
    align-items: center;

    ${({ top }) =>
        top &&
        css`
            top: ${top[0]}px;
        `}
    ${({ left }) =>
        left &&
        css`
            left: ${left[0]}px;
        `}
    
    ${({ bottom }) =>
        bottom &&
        css`
            bottom: ${bottom[0]}px;
        `}
    ${({ right }) =>
        right &&
        css`
            right: ${right[0]}px;
        `}
    
    @media ${respondAbove.xl} {
        ${({ top }) =>
            top &&
            css`
                top: ${top[1]}px;
            `}

        ${({ left }) =>
            left &&
            css`
                left: ${left[1]}px;
            `}
        
        ${({ bottom }) =>
            bottom &&
            css`
                bottom: ${bottom[1]}px;
            `}

        ${({ right }) =>
            right &&
            css`
                right: ${right[1]}px;
            `}
    }
`
